import { render, staticRenderFns } from "./CheckoutCustomerSelection.vue?vue&type=template&id=0432b60c&"
import script from "./CheckoutCustomerSelection.vue?vue&type=script&lang=js&"
export * from "./CheckoutCustomerSelection.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutCustomerSelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports